import React from "react";

const TotalSurfaceIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="#354052"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 5.325h11m-11 0 2-2m-2 2 2 2m9-2-2 2m2-2-2-2m7 7v11m0-11 2 2m-2-2-2 2m2 9-2-2m2 2 2-2m-18-7a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
    ></path>
  </svg>
);

export default TotalSurfaceIcon;
